
const Support = () => {

  return (
		<div className="pt-14 bg-main">
            <div className="flex flex-col justify-center">
				<div className="px-[40px] w-full">
                    <div className="overflow-x-auto w-full sm:w-[650px] mx-auto">
                        <h1 className="text-4xl ml-[33px] mb-5">Support</h1>
                        <div className="ml-[33px] font-helvetica space-y-4">
                            <p>Need help with a kit order, a file, or anything technical? Email our support team at <a href="mailto:support@thedesignergenesco.com" className="underline">support@thedesignergenesco.com</a> and we'll follow up shortly.</p>
                            <p>Be sure to include your client's full name and a clear description of the issue with supporting screenshots or Loom of what you're seeing for clarity and to expedite resolution. For coaching guidance, post details in the community forum with screenshots for reference.</p>
                        </div>
                    </div>
                </div>
            </div>
		</div>
  );
};

export default Support;
